import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import { MfaMethod, useUserMfaConfigurationQuery } from '@treams/treams-network';
import { Container, Heading, Paragraph, Separator, Spinner } from '@treams/treams-ui';

import TotpConfiguration from './mfa/TotpConfiguration';

export default function UserMfaConfiguration() {
	const { t } = useTranslation();
	const { data: userMfaConfigurationData } = useUserMfaConfigurationQuery();

	if (!userMfaConfigurationData) {
		return <Spinner centered />;
	}

	const workspaceSettings = userMfaConfigurationData.viewer.workspace.workspaceMfaSettings;
	const isTotpAllowed = workspaceSettings.allowedMethods.includes(MfaMethod.Totp);

	return (
		<Container py={5}>
			<Box maxWidth={550}>
				<Heading>{t('personalSettings.mfa.titleExtended')}</Heading>
				<Paragraph>{t('personalSettings.mfa.description')}</Paragraph>
				<br />
				<Paragraph color="secondary">
					{t(`personalSettings.mfa.workspaceStatus.${workspaceSettings.status.toLowerCase()}`)}
				</Paragraph>
			</Box>
			<Separator my={4} />
			<Flex>
				{isTotpAllowed && (
					<TotpConfiguration
						userMfaConfiguration={userMfaConfigurationData.viewer.userMfaConfiguration}
						workspaceMfaSettings={workspaceSettings}
					/>
				)}
			</Flex>
		</Container>
	);
}
